import { render, staticRenderFns } from "./RealmChat.vue?vue&type=template&id=12a294db&scoped=true"
import script from "./RealmChat.vue?vue&type=script&lang=js"
export * from "./RealmChat.vue?vue&type=script&lang=js"
import style0 from "./RealmChat.vue?vue&type=style&index=0&id=12a294db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a294db",
  null
  
)

export default component.exports